<template>
  <div class="clients farm-contact-list">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>

      <div class="page-wrapper">
        <div class="content container-fluid">
          <div class="page-header farm-page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Panen Kontak</h3>
                <p class="farm-page-subtitle">
                  Kelola hasil pencarian kontak bisnis dari Google Maps.
                </p>
              </div>
              <div class="col-auto farm-header-actions">
                <router-link to="/gmapkey" class="btn btn-white">
                  <i class="fa fa-key"></i> Pengaturan API Key
                </router-link>
                <button
                  type="button"
                  class="btn btn-primary"
                  :disabled="checkingApiKey"
                  @click="checkApiKeyBeforeSearch"
                >
                  <i class="fa" :class="checkingApiKey ? 'fa-spinner fa-spin' : 'fa-plus'"></i>
                  {{ checkingApiKey ? "Memeriksa..." : "Pencarian Baru" }}
                </button>
              </div>
            </div>
          </div>

          <div v-if="apiKeyNotice" class="farm-inline-note" :class="apiKeyNotice === 'missing' ? 'is-warning' : 'is-error'">
            <i class="fa fa-exclamation-circle"></i>
            <span>{{ apiKeyNoticeMessage }}</span>
            <div class="farm-note-actions">
              <router-link v-if="apiKeyNotice === 'missing'" to="/gmapkey" class="btn btn-primary btn-sm">
                Atur API Key
              </router-link>
              <button
                v-else
                type="button"
                class="btn btn-white btn-sm"
                :disabled="checkingApiKey"
                @click="checkApiKeyBeforeSearch"
              >
                <i class="fa" :class="checkingApiKey ? 'fa-spinner fa-spin' : 'fa-refresh'"></i>
                Coba lagi
              </button>
            </div>
            <button type="button" class="farm-note-close" aria-label="Tutup" @click="apiKeyNotice = ''">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div v-if="!apiKeyLoading && !apiKey && !apiKeyError && !apiKeyNotice" class="farm-inline-note is-warning">
            <i class="fa fa-exclamation-circle"></i>
            <span>Google Maps API Key belum diatur. Atur API Key sebelum memulai pencarian baru.</span>
            <router-link to="/gmapkey">Atur API Key</router-link>
          </div>
          <div v-if="apiKeyError" class="farm-inline-note is-error">
            <i class="fa fa-exclamation-circle"></i>
            <span>{{ apiKeyError }}</span>
            <button
              type="button"
              class="btn btn-white btn-sm"
              :disabled="apiKeyLoading"
              @click="getGmapKey"
            >
              <i class="fa" :class="apiKeyLoading ? 'fa-spinner fa-spin' : 'fa-refresh'"></i>
              Coba lagi
            </button>
          </div>

          <div class="farm-toolbar">
            <div class="farm-toolbar-filter">
              <label for="farm-contact-filter">Filter kontak</label>
              <select
                id="farm-contact-filter"
                v-model="serverParams.total_contact"
                class="form-control farm-filter-select"
                :disabled="loading"
                @change="onFilterChange"
              >
                <option value="">Semua hasil</option>
                <option value="found">Memiliki kontak</option>
              </select>
            </div>
            <div class="farm-toolbar-actions">
              <span class="farm-total-label">{{ totalRecords }} pencarian</span>
              <button
                type="button"
                class="btn btn-white farm-refresh-button"
                :disabled="loading"
                @click="refresh"
              >
                <i class="fa" :class="loading ? 'fa-spinner fa-spin' : 'fa-refresh'"></i>
                Muat ulang
              </button>
            </div>
          </div>

          <div v-if="selectedTable.length" class="farm-bulk-bar">
            <div class="farm-bulk-info">
              <strong>{{ selectedTable.length }} pencarian dipilih</strong>
              <label class="farm-merge-toggle">
                <input v-model="isMerge" type="checkbox" />
                Gabungkan kontak duplikat
              </label>
            </div>
            <div class="farm-bulk-actions">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                :disabled="isLoading"
                @click="selectDownloadExcelContact"
              >
                <i class="fa" :class="isLoading ? 'fa-spinner fa-spin' : 'fa-file-excel-o'"></i>
                Format Contact
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                :disabled="isLoading"
                @click="selectDownloadExcelBc"
              >
                <i class="fa" :class="isLoading ? 'fa-spinner fa-spin' : 'fa-file-excel-o'"></i>
                Format Broadcast
              </button>
              <button type="button" class="btn btn-white btn-sm" @click="hideActions">
                <i class="fa fa-times"></i> Tutup
              </button>
            </div>
          </div>

          <div v-if="linkDownload" class="farm-inline-note is-success">
            <i class="fa fa-check-circle"></i>
            <span>
              Data berhasil dibuat. Jika download otomatis tidak berfungsi,
              <a :href="linkDownload" target="_blank" rel="noopener noreferrer">buka tautan ini</a>.
            </span>
            <button type="button" class="farm-note-close" aria-label="Tutup" @click="closeMessageLinkDownload">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div v-if="downloadError" class="farm-inline-note is-error">
            <i class="fa fa-exclamation-circle"></i>
            <span>{{ downloadError }}</span>
            <button type="button" class="farm-note-close" aria-label="Tutup" @click="downloadError = ''">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div v-if="loading" class="farm-table-card">
            <div class="table-responsive">
              <table class="table farm-table mb-0">
                <thead>
                  <tr>
                    <th class="farm-check-col">
                      <input type="checkbox" disabled aria-label="Pilih semua hasil" />
                    </th>
                    <th>Keyword</th>
                    <th>Lokasi</th>
                    <th>Radius</th>
                    <th>Kontak</th>
                    <th>Status</th>
                    <th>Tanggal</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="8">
                      <Skeleton :count="4" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-else-if="loadError" class="farm-state-card">
            <span class="farm-state-icon is-error">
              <i class="fa fa-exclamation-triangle"></i>
            </span>
            <h4>Hasil pencarian belum dapat dimuat</h4>
            <p>{{ loadError }}</p>
            <button type="button" class="btn btn-primary" @click="refresh">
              <i class="fa fa-refresh"></i> Coba lagi
            </button>
          </div>

          <div v-else-if="!rows.length" class="farm-state-card">
            <span class="farm-state-icon">
              <i class="la la-map"></i>
            </span>
            <h4>{{ serverParams.total_contact === "found" ? "Belum ada hasil dengan kontak." : "Belum ada hasil Panen Kontak." }}</h4>
            <p v-if="serverParams.total_contact === 'found'">
              Tampilkan semua hasil atau mulai pencarian baru.
            </p>
            <p v-else>Mulai pencarian pertama Anda.</p>
            <div class="farm-state-actions">
              <button
                v-if="serverParams.total_contact === 'found'"
                type="button"
                class="btn btn-white"
                @click="clearContactFilter"
              >
                Tampilkan semua hasil
              </button>
              <button
                type="button"
                class="btn btn-primary"
                :disabled="checkingApiKey"
                @click="checkApiKeyBeforeSearch"
              >
                <i class="fa" :class="checkingApiKey ? 'fa-spinner fa-spin' : 'fa-search'"></i>
                {{ checkingApiKey ? "Memeriksa..." : "Mulai Pencarian" }}
              </button>
            </div>
          </div>

          <div v-else class="farm-table-card">
            <div class="table-responsive">
              <table class="table farm-table mb-0">
                <thead>
                  <tr>
                    <th class="farm-check-col">
                      <input
                        v-model="selectAllTable"
                        type="checkbox"
                        aria-label="Pilih semua hasil di halaman ini"
                      />
                    </th>
                    <th>Keyword</th>
                    <th>Lokasi</th>
                    <th>Radius</th>
                    <th>Kontak</th>
                    <th>Status</th>
                    <th>Tanggal</th>
                    <th class="text-right">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in rows" :key="row.id || index">
                    <td class="farm-check-col">
                      <input
                        v-model="selectedTable"
                        type="checkbox"
                        :value="row.id"
                        :aria-label="'Pilih pencarian ' + (row.keyword || '')"
                      />
                    </td>
                    <td class="text-wrap">
                      <span class="farm-keyword">{{ row.keyword || "-" }}</span>
                    </td>
                    <td class="text-wrap">
                      <a
                        v-if="getLocationUrl(row.location)"
                        :href="getLocationUrl(row.location)"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="farm-location-link"
                      >
                        <i class="fa fa-map-marker"></i>
                        {{ getLocationLabel(row.location) }}
                      </a>
                      <span v-else class="text-muted">-</span>
                    </td>
                    <td class="text-nowrap">{{ formatRadius(row.radius) }}</td>
                    <td>
                      <a
                        v-if="Number(row.total_contact) > 0"
                        href="#"
                        class="farm-contact-count"
                        data-toggle="modal"
                        data-target="#btnShowGroup"
                        @click="selectedGroup(row)"
                      >
                        {{ row.total_contact }}
                      </a>
                      <span v-else class="text-muted">0</span>
                    </td>
                    <td>
                      <span
                        class="farm-status-badge"
                        :class="'is-' + row.farm_status.tone"
                        :title="row.farm_status.description"
                      >
                        <i
                          class="fa"
                          :class="
                            row.farm_status.key === 'done'
                              ? 'fa-check-circle'
                              : row.farm_status.key === 'failed'
                              ? 'fa-exclamation-circle'
                              : 'fa-clock-o'
                          "
                        ></i>
                        {{ row.farm_status.label }}
                      </span>
                    </td>
                    <td class="text-nowrap">
                      <span :title="formatLocalDate(row.create_datetime)">
                        {{ formatDateAgo(row.create_datetime) }}
                      </span>
                    </td>
                    <td class="text-right">
                      <div
                        v-if="Number(row.total_contact) > 0"
                        class="dropdown action-label farm-download-dropdown"
                      >
                        <button
                          type="button"
                          class="btn btn-white btn-sm dropdown-toggle"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          :disabled="isLoading"
                        >
                          <i class="fa fa-download"></i> Download
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a class="dropdown-item" href="javascript:void(0)" @click="downloadExcelContact(row.id)">
                            Format Contact
                          </a>
                          <a class="dropdown-item" href="javascript:void(0)" @click="downloadExcelBc(row.id)">
                            Format Broadcast
                          </a>
                        </div>
                      </div>
                      <span v-else class="farm-no-action">Belum ada kontak</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="totalRecords > 0" class="farm-pagination">
            <div class="farm-pagination-info">
              <span>Menampilkan {{ displayFrom }}-{{ displayTo }} dari {{ totalRecords }}</span>
              <select
                v-model.number="serverParams.perPage"
                class="form-control farm-per-page"
                :disabled="loading"
                @change="onPerPageChange"
              >
                <option :value="10">10 / halaman</option>
                <option :value="20">20 / halaman</option>
                <option :value="30">30 / halaman</option>
                <option :value="50">50 / halaman</option>
              </select>
            </div>
            <div class="farm-pagination-actions">
              <button
                type="button"
                class="btn btn-white btn-sm"
                :disabled="loading || currentPage <= 1"
                @click="onPageChange(currentPage - 1)"
              >
                <i class="fa fa-chevron-left"></i> Sebelumnya
              </button>
              <span class="farm-page-label">Halaman {{ currentPage }} dari {{ maxPage }}</span>
              <button
                type="button"
                class="btn btn-white btn-sm"
                :disabled="loading || currentPage >= maxPage"
                @click="onPageChange(currentPage + 1)"
              >
                Selanjutnya <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <preview ref="modalPreview" />
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { Skeleton } from "vue-loading-skeleton";
import { nFormatter, timeAgo, formatLocalDate } from "@/utils/helper";
import {
  getApiErrorMessage,
  getFarmHeaderStatus,
  getGmapLocationLabel,
  getGmapLocationUrl
} from "@/utils/gmapContact";
import Preview from "./components/preview";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Preview
  },
  data() {
    return {
      isMerge: false,
      selectedTable: [],
      linkDownload: "",
      downloadError: "",
      apiKey: "",
      apiKeyLoading: true,
      apiKeyError: "",
      checkingApiKey: false,
      apiKeyNotice: "",
      apiKeyNoticeMessage: "",
      isLoading: false,
      loading: true,
      rows: [],
      totalRecords: 0,
      loadError: "",
      currentPage: 1,
      requestSequence: 0,
      serverParams: {
        total_contact: "",
        page: 1,
        perPage: 10
      }
    };
  },
  computed: {
    selectAllTable: {
      get() {
        return this.rows.length > 0 && this.selectedTable.length === this.rows.length;
      },
      set(value) {
        this.selectedTable = value ? this.rows.map(row => row.id) : [];
      }
    },
    maxPage() {
      return Math.max(1, Math.ceil(this.totalRecords / Number(this.serverParams.perPage || 10)));
    },
    displayFrom() {
      if (!this.totalRecords || !this.rows.length) {
        return 0;
      }
      return (this.currentPage - 1) * Number(this.serverParams.perPage || 10) + 1;
    },
    displayTo() {
      if (!this.totalRecords || !this.rows.length) {
        return 0;
      }
      return (this.currentPage - 1) * Number(this.serverParams.perPage || 10) + this.rows.length;
    }
  },
  created() {
    this.getGmapKey();
    this.loadItems();
  },
  methods: {
    async fetchGmapKeyValue() {
      const response = await this.$store.dispatch("gmapKey/getGmapKey");
      return String(response && response.data ? response.data : "").trim();
    },
    async getGmapKey() {
      this.apiKeyLoading = true;
      this.apiKeyError = "";
      try {
        this.apiKey = await this.fetchGmapKeyValue();
      } catch (error) {
        this.apiKeyError = getApiErrorMessage(
          error,
          "Status API Key belum dapat dimuat."
        );
      } finally {
        this.apiKeyLoading = false;
      }
    },
    async checkApiKeyBeforeSearch() {
      if (this.checkingApiKey) {
        return;
      }

      this.checkingApiKey = true;
      this.apiKeyNotice = "";
      this.apiKeyNoticeMessage = "";
      this.apiKeyError = "";

      try {
        const apiKey = await this.fetchGmapKeyValue();
        this.apiKey = apiKey;

        if (apiKey) {
          this.$router.push({ path: "/farm-contact/nearby-search" });
          return;
        }

        this.apiKeyNotice = "missing";
        this.apiKeyNoticeMessage =
          "Anda perlu mengatur Google Maps API Key sebelum mulai Panen Kontak.";
      } catch (error) {
        this.apiKeyNotice = "error";
        this.apiKeyNoticeMessage = getApiErrorMessage(
          error,
          "Status Google Maps API Key tidak dapat diperiksa. Periksa koneksi internet lalu coba lagi."
        );
      } finally {
        this.checkingApiKey = false;
      }
    },
    async loadItems() {
      const requestId = ++this.requestSequence;
      this.loading = true;
      this.loadError = "";

      const pageNumber = Math.max(1, Number(this.serverParams.page) || 1);
      const perPage = Math.max(1, Number(this.serverParams.perPage) || 10);
      const offset = (pageNumber - 1) * perPage;

      try {
        const response = await this.$store.dispatch("gmapKey/headerList", {
          total_contact: this.serverParams.total_contact,
          page: offset,
          perPage: perPage
        });

        if (requestId !== this.requestSequence) {
          return;
        }

        const payload = response && response.data ? response.data : {};
        const rows = Array.isArray(payload.data) ? payload.data : [];

        this.totalRecords = Number(payload.totalRecords) || 0;
        this.currentPage = pageNumber;
        this.rows = rows.map(row => {
          const item = Object.assign({}, row);
          item.farm_status = getFarmHeaderStatus(row);
          return item;
        });
      } catch (error) {
        if (requestId !== this.requestSequence) {
          return;
        }
        this.rows = [];
        this.totalRecords = 0;
        this.loadError = getApiErrorMessage(
          error,
          "Gagal memuat hasil Panen Kontak."
        );
      } finally {
        if (requestId === this.requestSequence) {
          this.loading = false;
        }
      }
    },
    refresh() {
      this.loadItems();
    },
    onFilterChange() {
      this.serverParams.page = 1;
      this.currentPage = 1;
      this.selectedTable = [];
      this.loadItems();
    },
    clearContactFilter() {
      this.serverParams.total_contact = "";
      this.onFilterChange();
    },
    onPageChange(page) {
      const target = Math.min(Math.max(1, Number(page) || 1), this.maxPage);
      if (target === this.currentPage) {
        return;
      }
      this.serverParams.page = target;
      this.currentPage = target;
      this.selectedTable = [];
      this.loadItems();
    },
    onPerPageChange() {
      this.serverParams.page = 1;
      this.currentPage = 1;
      this.selectedTable = [];
      this.loadItems();
    },
    getLocationUrl(location) {
      return getGmapLocationUrl(location);
    },
    getLocationLabel(location) {
      return getGmapLocationLabel(location);
    },
    formatRadius(radius) {
      const value = Number(radius);
      if (!value || value < 0) {
        return "-";
      }
      return nFormatter(value / 1000) + " KM";
    },
    formatLocalDate(unixTime) {
      if (!unixTime) {
        return "-";
      }
      return formatLocalDate(unixTime);
    },
    formatDateAgo(unixTime) {
      if (!unixTime) {
        return "-";
      }
      return timeAgo(unixTime);
    },
    selectedGroup(row) {
      this.$refs.modalPreview.getGroupSelected(row);
    },
    hideActions() {
      this.selectedTable = [];
    },
    closeMessageLinkDownload() {
      this.linkDownload = "";
    },
    buildBulkDownloadParam() {
      const dataParam = {
        columnFilters: {
          header_id: this.selectedTable.join(","),
          is_merge: this.isMerge ? "merge" : ""
        },
        page: 0,
        perPage: 20
      };
      return dataParam;
    },
    selectDownloadExcelContact() {
      if (!this.selectedTable.length) {
        this.downloadError = "Pilih minimal satu hasil pencarian.";
        return;
      }
      this.downloadExcelContact(this.buildBulkDownloadParam());
    },
    selectDownloadExcelBc() {
      if (!this.selectedTable.length) {
        this.downloadError = "Pilih minimal satu hasil pencarian.";
        return;
      }
      this.downloadExcelBc(this.buildBulkDownloadParam());
    },
    downloadExcelContact(headerId) {
      const dataParam =
        headerId && typeof headerId === "object"
          ? headerId
          : {
              columnFilters: { header_id: headerId },
              page: 0,
              perPage: 20
            };
      this.runDownload("gmapKey/downloadExcelContact", dataParam);
    },
    downloadExcelBc(headerId) {
      const dataParam =
        headerId && typeof headerId === "object"
          ? headerId
          : {
              columnFilters: { header_id: headerId },
              page: 0,
              perPage: 20
            };
      this.runDownload("gmapKey/downloadExcelBc", dataParam);
    },
    runDownload(action, dataParam) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.downloadError = "";
      this.linkDownload = "";

      this.$store
        .dispatch(action, dataParam)
        .then(response => {
          const link = response && response.data ? response.data : "";
          if (!link) {
            this.downloadError = "Tautan download tidak tersedia. Silakan coba lagi.";
            return;
          }
          this.linkDownload = link;
          window.open(link, "_blank");
        })
        .catch(error => {
          this.downloadError = getApiErrorMessage(
            error,
            "Download gagal dibuat. Silakan coba lagi."
          );
        })
        .then(() => {
          this.isLoading = false;
        });
    }
  },
  beforeDestroy() {
    this.$root.$off("downloadExcelBc");
    this.$root.$off("downloadExcelContact");
  },
  mounted() {
    this.$root.$on("downloadExcelBc", headerId => {
      this.downloadExcelBc(headerId);
    });
    this.$root.$on("downloadExcelContact", headerId => {
      this.downloadExcelContact(headerId);
    });
  },
  name: "farmContactList"
};
</script>

<style scoped>
.farm-contact-list /deep/ .page-wrapper {
  background: #f8fafc;
}

.farm-page-header {
  margin-bottom: 22px;
}

.farm-page-subtitle {
  margin: 6px 0 0;
  color: #667085;
  font-size: 14px;
  line-height: 1.5;
}

.farm-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.farm-header-actions .btn {
  height: 40px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
}

.farm-inline-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;
  padding: 11px 13px;
  border: 1px solid transparent;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.5;
}

.farm-inline-note a {
  font-weight: 700;
}

.farm-note-actions {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  margin-left: 4px;
}

.farm-note-actions .btn,
.farm-inline-note > .btn {
  height: 30px;
  padding: 0 10px;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
}

.farm-inline-note.is-warning {
  color: #b54708;
  background: #fffaeb;
  border-color: #fedf89;
}

.farm-inline-note.is-error {
  color: #b42318;
  background: #fef3f2;
  border-color: #fecdca;
}

.farm-inline-note.is-success {
  color: #067647;
  background: #ecfdf3;
  border-color: #abefc6;
}

.farm-note-close {
  margin-left: auto;
  padding: 0 2px;
  color: inherit;
  background: transparent;
  border: 0;
  line-height: 1;
}

.farm-toolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 16px;
}

.farm-toolbar-filter label {
  display: block;
  margin-bottom: 6px;
  color: #667085;
  font-size: 12px;
  font-weight: 700;
}

.farm-filter-select {
  width: 190px;
  height: 38px;
  border-color: #d0d5dd;
  border-radius: 8px;
  font-size: 13px;
}

.farm-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.farm-total-label {
  color: #98a2b3;
  font-size: 12px;
}

.farm-refresh-button {
  height: 38px;
  border-color: #d0d5dd;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}

.farm-bulk-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px 14px;
  background: #ffffff;
  border: 1px solid #ffe1bd;
  border-radius: 10px;
}

.farm-bulk-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  color: #344054;
  font-size: 13px;
}

.farm-merge-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  color: #667085;
  font-size: 12px;
  font-weight: 600;
}

.farm-bulk-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
}

.farm-bulk-actions .btn {
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
}

.farm-table-card {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);
}

.farm-table {
  margin: 0;
}

.farm-table thead th {
  padding: 13px 14px;
  color: #667085;
  background: #fbfcfe;
  border-bottom: 1px solid #eef2f6;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
}

.farm-table tbody td {
  padding: 14px;
  color: #344054;
  border-top: 1px solid #f2f5f8;
  font-size: 13px;
  vertical-align: middle;
}

.farm-table tbody tr:hover {
  background: #fffdf9;
}

.farm-check-col {
  width: 42px;
  text-align: center;
}

.farm-keyword {
  color: #172033;
  font-weight: 600;
}

.farm-location-link {
  color: #b45309;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.farm-location-link:hover {
  color: #92400e;
  text-decoration: underline;
}

.farm-contact-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 26px;
  padding: 0 8px;
  color: #b45309;
  background: #fff7ef;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
}

.farm-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.farm-status-badge.is-success {
  color: #067647;
  background: #ecfdf3;
}

.farm-status-badge.is-warning {
  color: #b54708;
  background: #fffaeb;
}

.farm-status-badge.is-danger {
  color: #b42318;
  background: #fef3f2;
}

.farm-download-dropdown .btn {
  height: 32px;
  padding: 0 10px;
  border-color: #d0d5dd;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.farm-no-action {
  color: #98a2b3;
  font-size: 12px;
  white-space: nowrap;
}

.farm-state-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 52px 22px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 14px;
}

.farm-state-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-bottom: 14px;
  color: #b45309;
  background: #fff7ef;
  border-radius: 14px;
  font-size: 24px;
}

.farm-state-icon.is-error {
  color: #b42318;
  background: #fef3f2;
}

.farm-state-card h4 {
  margin: 0 0 6px;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
}

.farm-state-card p {
  max-width: 430px;
  margin: 0 0 16px;
  color: #667085;
  font-size: 13px;
  line-height: 1.6;
}

.farm-state-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.farm-state-actions .btn {
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
}

.farm-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
}

.farm-pagination-info,
.farm-pagination-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.farm-pagination-info {
  color: #667085;
  font-size: 12px;
}

.farm-per-page {
  width: 130px;
  height: 34px;
  border-color: #d0d5dd;
  border-radius: 7px;
  font-size: 12px;
}

.farm-pagination-actions .btn {
  height: 34px;
  border-color: #d0d5dd;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 600;
}

.farm-page-label {
  color: #667085;
  font-size: 12px;
}

@media (max-width: 767.98px) {
  .farm-header-actions {
    margin-top: 12px;
  }

  .farm-header-actions .btn {
    flex: 1 1 auto;
  }

  .farm-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .farm-filter-select {
    width: 100%;
  }

  .farm-toolbar-actions {
    justify-content: space-between;
  }

  .farm-pagination {
    align-items: stretch;
    flex-direction: column;
  }

  .farm-pagination-info,
  .farm-pagination-actions {
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/farmContact/list.vue